import React, { useState } from "react";
import Card from "../components/UiComponents/Card";
import CenteredViewContainer from "../components/UiComponents/CenteredViewContainer";
import styled from 'styled-components';
import IconLogo from "../components/UiComponents/IconLogo";
import theme from "../UI/theme";
import LogoutButton from "../components/authentication/LogoutButton";
import InputField from "../components/UiComponents/InputField";
import Button from "../components/UiComponents/Button";

const Logo = styled(IconLogo)`
    width: 30px;
    height: 30px;
`

const TitleContainer = styled.div`
    display: flex;
    align-items: center;

    div {
        padding-right: 16px;
    }
`

const Link = styled.a`
    color: ${theme.colors.darkSpace20};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`

const QuestionaireTitle = styled.div`

    width: 100%;
    text-align: center;

    margin-top: 32px;
    gap: 0;

    h3 {
        margin: 0;
        padding: 0;
    }
`

const MultiChoiseRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding: 12px 6px;
`
const MultiChoiseItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    span {
        font-size: 32px;
    }

    p {
        margin: 0;
        padding: 0;
        font-size: 12px;
    }
`

const Disclaimer = styled.p`
    width: 100%;
    font-size: 12px;
    font-style: italic;
    text-align: center;
`

const GOOGLE_FORM_ID = '1FAIpQLSe9vrYYKC2qDvYGBBc_SLfPc2VX6Wq6l1IoD01sC9YbAKfTHQ';
const GOOGLE_FORM_ACTION = `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/formResponse`;

const GOOGLE_ENTRY = {
  customerId: 'entry.943474387',
  userEmail: 'entry.317746793',
  lossImpact: 'entry.1170897456',
  productHappinessValue: 'entry.540971310',
  happinessSentiment: "entry.1804105161",
  freeText: 'entry.564893269',
};

// Google Forms wants the exact label text for the first question:
const GOOGLE_LOSS_IMPACT_TEXT = {
    1: "😢 - I'm upset about this",
    2: "😐 - It's fine / I don't use it",
    3: "😊 - I'm happy it's gone",
};

const GOOGLE_HAPPINESS_SENTIMENT = {
    1: "🤮 - Very Unhappy",
    2: "😢 - Unhappy",
    3: "😐 - Neutral",
    4: "😊 - Happy",
    5: "😁 - Very Happy",
    6: "🤩 - Extremely Happy"
};

const LockedOutView = ({user, customer }) => {

    console.log(user, customer);

    const [feedBackStep, setFeedBackStep] = useState(1);
    const [freeText, setFreeText] = useState('');

    const [feedback, setFeedback] = useState({
        lossImpact: null,
        productHappiness: null,
        freeText: ''
    });

    const timezone = customer?.timezone || '';

    var phone;
    if (timezone.includes('America')) phone = '+1 (669) 666-6834';
    else if (timezone.includes('London')) phone = '+44 788 887 2286';
    else phone = '+47 22 22 22 33';

    const lossImpact = [
        {type: 'LOSS_IMPACT', value: 1, tag: "😢", label: "I'm upset about this"},
        {type: 'LOSS_IMPACT', value: 2, tag: "😐", label: "It's fine / I don't use it"},
        {type: 'LOSS_IMPACT', value: 3, tag: "😊", label: "I'm happy it's gone"}
    ]

    const happyness = [
        {type: 'PRODUCT_HAPPINESS', value: 1, tag: "🤮", label: "Very Unhappy"},
        {type: 'PRODUCT_HAPPINESS', value: 2, tag: "😢", label: "Unhappy"},
        {type: 'PRODUCT_HAPPINESS', value: 3, tag: "😐", label: "Neutral"},
        {type: 'PRODUCT_HAPPINESS', value: 4, tag: "😊", label: "Happy"},
        {type: 'PRODUCT_HAPPINESS', value: 5, tag: "😁", label: "Very Happy"},
        {type: 'PRODUCT_HAPPINESS', value: 6, tag: "🤩", label: "Extremely Happy"}
    ]

    const setImpact = (item) => {
        setFeedback({...feedback, lossImpact: item.value});
        setFeedBackStep(2);
    }

    const setHappyness = (item) => {
        setFeedback({...feedback, productHappiness: item});
        setFeedBackStep(3);
    }

    const submit = async    () => {
        setFeedBackStep(4);
        const completeFeedback = {...feedback, freeText};
        setFeedback(completeFeedback);
        
        // submit google form here!

        // fire-and-forget; you won't get a readable response in no-cors mode
        try {
            await submitToGoogleForm(completeFeedback);
            // optionally set some "thank you" UI state here
        } catch (e) {
            // optionally show a fallback message
            console.error(e);
        }

    }

        

    async function submitToGoogleForm({ lossImpact, productHappiness, freeText }) {

        console.log('submitting for customer: ', customer?.customerId);
        console.log('with email: ', user?.email);

        const data = new URLSearchParams({
            [GOOGLE_ENTRY.customerId]: String(customer?.customerId ?? "unknown"),
            [GOOGLE_ENTRY.userEmail]: String(user?.email ?? "unknown"),
            [GOOGLE_ENTRY.lossImpact]: GOOGLE_LOSS_IMPACT_TEXT[lossImpact] ?? "",
            [GOOGLE_ENTRY.productHappinessValue]: String(productHappiness.value ?? ""),
            [GOOGLE_ENTRY.happinessSentiment]: String(GOOGLE_HAPPINESS_SENTIMENT[productHappiness.value] ?? ""),
            [GOOGLE_ENTRY.freeText]: freeText ?? "",
        });

        console.log([...data.entries()]);

        await fetch(GOOGLE_FORM_ACTION, {
            method: "POST",
            mode: "no-cors",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: data.toString(),
        });
    };

    return <CenteredViewContainer>
        <Card>
            <TitleContainer>
                <Logo />
                <h3>No Active Subscription</h3>
            </TitleContainer>
            <p>To regain access, please call us on <Link href={`tel:${phone}`}>{phone}</Link> and we’ll help you get set up again.</p>

            {feedBackStep === 1 && (<>
                <QuestionaireTitle>
                    <h3>How do you feel about losing access to Waved?</h3>
                </QuestionaireTitle>
            
                <MultiChoiseRow>
                    {lossImpact.map(item => (
                        <MultiChoiseItem key={item.value} onClick={() => setImpact(item)}>
                            <span>{item.tag}</span>
                            <p>{item.label}</p>
                        </MultiChoiseItem>
                    ))}
                </MultiChoiseRow>
            </>)}


            {feedBackStep === 2 && (
                <>
                    <QuestionaireTitle>
                        <h3>How happy were you with Waved?</h3>
                    </QuestionaireTitle>
                    <MultiChoiseRow>
                        {happyness.map(h => (
                            <MultiChoiseItem key={h.value} onClick={() => setHappyness(h)}>
                                <span>{h.tag}</span>
                                <p>{h.label}</p>
                            </MultiChoiseItem>
                        ))} 
                    </MultiChoiseRow>
                </>
            )}

            {feedBackStep === 3 && (
                <>
                    <QuestionaireTitle>
                        <h3>✏️ Do you have any feedback to share ?</h3>
                    </QuestionaireTitle><br />
                    <InputField value={freeText} onChange={e => setFreeText(e.target.value)} />
                    <div style={{width: '100%', display: 'flex', justifyContent: 'center', padding: '20px'}}>
                        <Button primary onClick={submit}>Share Feedback</Button></div>
                </>
            )}

            {feedBackStep > 3 && (
                <>
                    <QuestionaireTitle>
                        <h3>🤗 Thank you for your feedback! 🤗</h3>
                        <p>Your input helps us improve our service.</p>
                        <br></br>
                    </QuestionaireTitle>
                </>
            )}

            <Disclaimer>This feedback is completely anonymous and helps us understand the impact of subscription changes.</Disclaimer>

            




            <LogoutButton />
        </Card>
    </CenteredViewContainer>
}

export default LockedOutView;